import { Constants } from "./constants";

export const APIRBAC = {
  Policies: () => {
    return fetch(`${Constants.API_SERVER()}/api/v1/rbac/policies`, {
      method: "GET",
      credentials: "include",
    });
  },
  Roles: () => {
    return fetch(`${Constants.API_SERVER()}/api/v1/rbac/roles`, {
      method: "GET",
      credentials: "include",
    });
  },
  AddPolicy: (data) => {
    return fetch(`${Constants.API_SERVER()}/api/v1/rbac/policy`, {
      method: "POST",
      body: JSON.stringify(data),
      credentials: "include",
    });
  },
  DeletePolicy: (data) => {
    return fetch(`${Constants.API_SERVER()}/api/v1/rbac/policy`, {
      method: "DELETE",
      body: JSON.stringify(data),
      credentials: "include",
    });
  },
};
